import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { getProductId } from '../../common/utils/getProductId';
export const stringToBoolean = value => {
  if (typeof value !== 'string') {
    return value;
  }
  const val = value === null || value === void 0 ? void 0 : value.toLowerCase().trim();
  return val === 'true' || val === 'false' ? JSON.parse(val) : val;
};
export const getSelected = (name, form) => state => {
  var _formData$value;
  const formData = formValueSelector(form)(state, name);
  return formData ? stringToBoolean(formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.value) : null;
};
export const useIsSelected = (form, name) => useSelector(state => getSelected(name, form)(state));
export const getGraphQlSelection = (name, type) => ({
  form,
  state
}) => {
  const UiSelection = getSelected(name, form)(state);
  const productId = getProductId(name);
  if (!productId || !UiSelection) {
    return null;
  }
  if (type === 'traveler') {
    return {
      productId,
      selectionTraveler: formValueSelector(form)(state, name).travelerIds
    };
  }
  return {
    productId,
    selectionNone: true
  };
};
export const getPrice = (name, form) => state => {
  const formData = formValueSelector(form)(state, name);
  return formData ? formData.value.priceRaw : null;
};
//# sourceMappingURL=selection.js.map